var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.myHawkLoginToken !== '')?_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.iframeUrl,"frameborder":"0","sandbox":"allow-same-origin allow-scripts allow-forms allow-top-navigation"}}):_c('b-overlay',{staticClass:"h-100",attrs:{"show":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e148d3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HawkIframe.vue
// module id = 2291
// module chunks = 0